import { render } from "./project-attachments-button.vue?vue&type=template&id=48595586"
import script from "./project-attachments-button.vue?vue&type=script&lang=js"
export * from "./project-attachments-button.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__